import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

export const TableField = ({
                               cb = () => {
                               }, values: _values, errors, field, selectIcon = faCheck, disabled = false
                           }) => {
    const value = field.name ? _values[field.name] : _values;
    const error = errors ? errors[field.name] : null;
    const [values, setValues] = useState(value || field.rows.map(() => field.columns.map(() => false)));

    const selectCell = (ri, ci) => {
        if (disabled) return;
        
        let cellValues = values.map((val, i) => (i === ri ? val.map((val, i) => (i === ci ? !val : val)) : val));
        setValues(cellValues);
        if (field.name) {
            cb({ [field.name]: cellValues });
        } else {
            cb(cellValues);
        }
    };

    // const countSelected = () => {
    //     let count = 0;
    //     values.forEach((row) =>
    //         row.forEach((col) => {
    //             if (col) count++;
    //         })
    //     );
    //     return count;
    // };

    useEffect(() => {
        if (field.rows.length !== values.length || (values.length > 0 && field.columns.length !== values[0].length)) {
            let newValues = field.rows.map(() => field.columns.map(() => false));
            setValues(newValues);
            if (field.name) {
                cb({ [field.name]: newValues });
            } else {
                cb(newValues);
            }
        }
    }, [field.columns.length, field.rows.length]);

    const getArr = (arr, ri, ci) =>
        arr && Array.isArray(arr) && arr.length >= ri && Array.isArray(arr[ri]) && arr[ri].length >= ci && arr[ri][ci];

    return (
        <div className="my-2">
            <label>{field.label && field.label + (field.rules.includes("required") ? " *" : "")}</label>
            <div className={error ? "border border-danger rounded p-1" : ""}>
                <div className="table-responsive">
                    <table className="table table-bordered">
                        <thead>
                        <tr>
                            <th scope="col"></th>
                            {field.columns.map((col) => (
                                <th key={col} scope="col">
                                    {col}
                                </th>
                            ))}
                        </tr>
                        </thead>
                        <tbody>
                        {field.rows.map((row, ri) => (
                            <tr key={ri}>
                                <th scope="row">{row}</th>
                                {field.columns.map((col, ci) => (
                                    <th
                                        key={ci}
                                        scope="col"
                                        style={{
                                            backgroundColor: getArr(field.disabledTimes, ri, ci) ? "#c8ccd0" : ""
                                        }}
                                        onClick={() =>
                                            cb && !getArr(field.disabledTimes, ri, ci) ? selectCell(ri, ci) : null
                                        }
                                        className="text-center"
                                    >
                                        {!getArr(field.disabledTimes) && getArr(values, ri, ci) ? (
                                            <FontAwesomeIcon icon={selectIcon} />
                                        ) : (
                                            ""
                                        )}
                                    </th>
                                ))}
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
            </div>
            {error && (
                <small className="text-danger">
                    <strong>{error}</strong>
                </small>
            )}
        </div>
    );
};
